/**
 * Form 24Q export — PDF summary + CSV for TRACES preparation.
 */
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

function inr(n) {
  const v = Number(n || 0);
  return `₹${v.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function downloadForm24QPdf(data) {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const er = data.employer || {};

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("FORM 24Q — Quarterly TDS Return (Summary)", 148, 14, { align: "center" });
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text(
    `FY ${data.financialYear || "—"} · ${data.quarter || "—"} (${data.quarterLabel || ""})`,
    148,
    20,
    { align: "center" }
  );

  let y = 28;
  doc.text(`Employer: ${er.name || "—"}`, 14, y);
  doc.text(`TAN: ${er.tan || "—"}`, 200, y);
  y += 5;
  doc.text(`Total TDS: ${inr(data.totalTds)}`, 14, y);
  doc.text(`Employees: ${data.employeeCount ?? 0}`, 200, y);
  y += 8;

  const aggregates = data.employeeAggregates || [];
  autoTable(doc, {
    startY: y,
    head: [["#", "Emp Code", "Name", "PAN", "Regime", "Quarter TDS", "Months"]],
    body: aggregates.map((r, i) => [
      i + 1,
      r.empCode || "—",
      r.name || "—",
      r.pan || "—",
      r.taxRegime || "—",
      inr(r.totalTds),
      (r.months || []).join(", "),
    ]),
    styles: { fontSize: 7 },
    headStyles: { fillColor: [30, 58, 95] },
    margin: { left: 14, right: 14 },
  });

  const filename = `Form24Q_${data.financialYear}_${data.quarter}.pdf`;
  doc.save(filename);
  return filename;
}

/** Simplified CSV for TRACES / payroll team review */
export function downloadForm24QCsv(data) {
  const aggregates = data.employeeAggregates || [];
  const er = data.employer || {};
  const lines = [
    `Form 24Q,${data.financialYear},${data.quarter}`,
    `Employer,${er.name || ""}`,
    `TAN,${er.tan || ""}`,
    `Total TDS,${data.totalTds || 0}`,
    "",
    "Serial,Emp Code,Employee Name,PAN,Tax Regime,Quarter TDS,Months Count",
  ];

  aggregates.forEach((r, i) => {
    const name = String(r.name || "").replace(/,/g, " ");
    lines.push(
      [
        i + 1,
        r.empCode || "",
        `"${name}"`,
        r.pan || "",
        r.taxRegime || "",
        r.totalTds || 0,
        (r.months || []).length,
      ].join(",")
    );
  });

  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Form24Q_${data.financialYear}_${data.quarter}_TRACES.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
